import * as actionTypes from "./actionTypes";

export const fetchZipCodeData = (zipTitle, data) => ({
  type: actionTypes.fetchZipcodeDataType,
  zipTitle: zipTitle,
  payload: data
});

export const resetZipCode = (zipTitle, field) => ({
  type: actionTypes.resetZipCodeDataType,
  zipTitle: zipTitle,
  field: field
});

export const resetAllZipFields = (zipTitle) => ({
  type:  actionTypes.resetAllZipFielsType,
  zipTitle: zipTitle
});

export const flushZipCode = () => ({
  type: actionTypes.flushZipcodeFieldType

});